import { MultiValuedList } from '../../../MultiValuedList'
import { LinkMultiValuedListItem } from '../LinkMultiValuedListItem'
import { LinkMultiValuedListMoreItem } from '../LinkMultiValuedListMoreItem'

import { filterByValue } from './LinkMultiValuedList.utils'

function LinkMultiValuedList({
  Item = LinkMultiValuedListItem,
  MoreItem = LinkMultiValuedListMoreItem,
  filter = filterByValue,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default LinkMultiValuedList
